import VerifyScanIndicator from './VerifyScanIndicator'

type Props = {
  heroSrc: string
  serviceTitle: string
  ready?: boolean
}

export default function VerifyLoadingHero({ heroSrc, serviceTitle, ready = false }: Props) {
  return (
    <div
      className={`verify-loading-hero${ready ? ' verify-loading-hero--ready' : ''}`}
      role="img"
      aria-label={serviceTitle}
    >
      <img className="verify-loading-hero__img" src={heroSrc} alt="" />
      <div className="verify-loading-hero__fade" aria-hidden="true" />
      <div className="verify-loading-hero__glow-bottom" aria-hidden="true" />
      <VerifyScanIndicator ready={ready} />
    </div>
  )
}
